import { config } from 'api';
import { clientCookies } from 'utils/cookies';
import { UNKNOWN_ERROR } from 'utils/errors';
import { Url } from 'lib/utils/url';
import ulpCookies from '../ulpCookies';
import { setUserPreference } from 'utils/userPreferences/actions/userPreferences';

export const EXCLUDED_ENTRY_POINT = 'EXCLUDED_ENTRY_POINT';
export const TOGGLE_IS_TEMPORARY_HIDDEN = 'TOGGLE_IS_TEMPORARY_HIDDEN';
export const RECEIVE_ULP_BANNER_DATA = 'RECEIVE_ULP_BANNER_DATA';
export const RECEIVE_ULP_BANNER_DATA_ERROR = 'RECEIVE_ULP_BANNER_DATA_ERROR';
export const USER_HID_BANNER = 'USER_HID_BANNER';

export function receiveUlpBannerData(ulp) {
  return {
    type: RECEIVE_ULP_BANNER_DATA,
    ulp,
  };
}

export function receiveUlpBannerDataError(json) {
  return {
    type: RECEIVE_ULP_BANNER_DATA_ERROR,
    error: json.error,
  };
}

export function ulpBannerUrl(campaignId) {
  const url = new Url(`${config.apiBasePath}/ulp-banner`);
  if (campaignId) {
    url.addQueryParameter('campaignId', campaignId);
  }
  return url.toString();
}

export function fetchUlpBannerData(campaignId) {
  return (dispatch, getState, { network }) =>
    network.get(ulpBannerUrl(campaignId))
      .then(data => {
        dispatch(receiveUlpBannerData(data));
      })
      .catch(err => {
        dispatch(receiveUlpBannerDataError(err.data || UNKNOWN_ERROR));
      });
}

export function setUserHidBanner() {
  return {
    type: USER_HID_BANNER,
  };
}

export function setUserHidBannerCookieIfNotPresent() {
  if (!(ulpCookies.USER_HID_BANNER.name in clientCookies.getAll())) {
    clientCookies.set(ulpCookies.USER_HID_BANNER.name, true, ulpCookies.USER_HID_BANNER.options);
  }
}

export function setUserHidBannerData() {
  setUserHidBannerCookieIfNotPresent();
  return dispatch => dispatch(setUserHidBanner());
}

export function setExcludedEntryPointCookieIfNotPresent() {
  if (clientCookies && !(ulpCookies.EXCLUDED_ENTRY_POINT.name in clientCookies.getAll())) {
    clientCookies.set(ulpCookies.EXCLUDED_ENTRY_POINT.name, true, ulpCookies.EXCLUDED_ENTRY_POINT.options);
  }
}

export function setExcludedEntryPointData() {
  setExcludedEntryPointCookieIfNotPresent();
  return dispatch => dispatch(setUserPreference('EEP', true));
}

export function toggleIsTemporaryHidden(isTemporaryHidden = false) {
  return {
    type: TOGGLE_IS_TEMPORARY_HIDDEN,
    isTemporaryHidden,
  };
}
